import Icon, { ICON_BOTTOM } from '~/components/icon/index.js';

const IconBottom = () => <Icon className="collapse__continue-icon" type={ICON_BOTTOM} />;

export default IconBottom;
